// extracted by css-extract-rspack-plugin
export default {"submitButton":"EBS1ISDCqY0At_co","submitButtonContainer":"Rfer8e_ZQYA2eu75","FormGroupRow":"IJYqvktJ07QSlOTp"};